import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VBtn,
    {
      staticClass:
        "branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1 lpu-doctors-show-all-link",
      attrs: {
        depressed: "",
        color: "primary",
        height: "52",
        href: _vm.href,
        block: _setup.isMobile,
        "data-qa": "lpu_doctors_list_show_all",
      },
    },
    [_vm._v("\n  " + _vm._s(_vm.label) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }